export interface AnalyticsErrorEventInputModel {
  ['error_type']: 'backend' | 'form' | 'input';
  ['error_code']: string;
  ['error_message']: string;
  ['error_field']?: string;
  ['is_fatal']: boolean;
}
